const urlWithAuthParams = (url, options) => `${url}?tenantId=${options.tenantId}&clientSecret=${options.clientSecret}&clientId=${options.clientId}`;
export default urlWithAuthParams;
